import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import logo from 'assets/img/illustrations/logo_vox_top.png';
import logoWhite from 'assets/img/illustrations/logo_vox_top_white.png';
import { useAppContext } from 'Main';

const LogoLogin = ({ at, width, className, ...rest }) => {
  const {
    config: { theme }
  } = useAppContext();

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-1': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-2 mb-2': at === 'auth'
          },
          className
        )}
      >
        <img className="me-2" src={theme === 'light' || theme === 'auto' ? logo : logoWhite} alt="Logo" width={width} />
      </div>
    </Link>
  );
};

LogoLogin.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string
};

LogoLogin.defaultProps = { at: 'auth', width: 58 };

export default LogoLogin;
